import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const StepCompanyStructure = ({ data = {}, onSubmit, onBack, saving }) => {
  const [organizational_chart, setOrganizationalChart] = useState(false);
  const [company_regulations, setCompanyRegulations] = useState(false);
  const [organizational_model_231_01, setOrganizationalModel231] = useState(false);
  const [model_ot23_isi_inail, setModelOt23] = useState(false);
  const [code_of_ethics, setCodeOfEthics] = useState(false);
  const [legality_rating, setLegalityRating] = useState(false);
  const [sustainability_report, setSustainabilityReport] = useState(false);
  const [secondary_offices, setSecondaryOffices] = useState({ present: false, locations: "" });
  const [industry_association_memberships, setIndustryAssociation] = useState({
    present: false,
    which: "",
  });
  const [interprofessional_funds, setInterprofessionalFunds] = useState({
    present: false,
    which: "",
  });
  const [bilateral_entity, setBilateralEntity] = useState({ present: false, which: "" });

  useEffect(() => {
    setOrganizationalChart(!!data.organizational_chart);
    setCompanyRegulations(!!data.company_regulations);
    setOrganizationalModel231(!!data.organizational_model_231_01);
    setModelOt23(!!data.model_ot23_isi_inail);
    setCodeOfEthics(!!data.code_of_ethics);
    setLegalityRating(!!data.legality_rating);
    setSustainabilityReport(!!data.sustainability_report);
    setSecondaryOffices(data.secondary_offices ?? { present: false, locations: "" });
    setIndustryAssociation(data.industry_association_memberships ?? { present: false, which: "" });
    setInterprofessionalFunds(data.interprofessional_funds ?? { present: false, which: "" });
    setBilateralEntity(data.bilateral_entity ?? { present: false, which: "" });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      organizational_chart,
      company_regulations,
      organizational_model_231_01,
      model_ot23_isi_inail,
      code_of_ethics,
      legality_rating,
      sustainability_report,
      secondary_offices: {
        present: secondary_offices.present,
        locations: secondary_offices.present ? secondary_offices.locations || null : null,
      },
      industry_association_memberships: {
        present: industry_association_memberships.present,
        which: industry_association_memberships.present
          ? industry_association_memberships.which || null
          : null,
      },
      interprofessional_funds: {
        present: interprofessional_funds.present,
        which: interprofessional_funds.present ? interprofessional_funds.which || null : null,
      },
      bilateral_entity: {
        present: bilateral_entity.present,
        which: bilateral_entity.present ? bilateral_entity.which || null : null,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep2Title") || "Struttura Aziendale"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep2Description") ||
            "Descrivi la composizione e l'organizzazione interna della tua azienda per comprendere la sua solidità e capacità operativa."}
        </p>
      </div>
      <div className="p-fluid grid" style={{rowGap: "1rem"}}>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="organizational_chart"
            checked={organizational_chart}
            onChange={(e) => setOrganizationalChart(e.checked)}
          />
          <label htmlFor="organizational_chart">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2OrganizationalChartLabel") || "Organigramma"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2OrganizationalChartHelp") ||
                "L'azienda ha un organigramma?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="company_regulations"
            checked={company_regulations}
            onChange={(e) => setCompanyRegulations(e.checked)}
          />
          <label htmlFor="company_regulations">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2CompanyRegulationsLabel") ||
                "Regolamento Aziendale"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2CompanyRegulationsHelp") ||
                "Esiste un regolamento interno?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="organizational_model_231_01"
            checked={organizational_model_231_01}
            onChange={(e) => setOrganizationalModel231(e.checked)}
          />
          <label htmlFor="organizational_model_231_01">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2OrganizationalModel231Label") ||
                "Modello Organizzativo 231/01"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2OrganizationalModel231Help") ||
                "Adotta il Modello 231/01?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="model_ot23_isi_inail"
            checked={model_ot23_isi_inail}
            onChange={(e) => setModelOt23(e.checked)}
          />
          <label htmlFor="model_ot23_isi_inail">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2ModelOt23Label") || "Modello OT23 - ISI INAIL"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2ModelOt23Help") ||
                "L'azienda applica modelli OT23/INAIL?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="code_of_ethics"
            checked={code_of_ethics}
            onChange={(e) => setCodeOfEthics(e.checked)}
          />
          <label htmlFor="code_of_ethics">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2CodeOfEthicsLabel") || "Codice Etico"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2CodeOfEthicsHelp") ||
                "L'azienda ha un codice etico?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="legality_rating"
            checked={legality_rating}
            onChange={(e) => setLegalityRating(e.checked)}
          />
          <label htmlFor="legality_rating">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2LegalityRatingLabel") || "Rating di Legalità"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2LegalityRatingHelp") ||
                "Ha ottenuto un rating di legalità?"}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="sustainability_report"
            checked={sustainability_report}
            onChange={(e) => setSustainabilityReport(e.checked)}
          />
          <label htmlFor="sustainability_report">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep2SustainabilityReportLabel") ||
                "Bilancio di Sostenibilità"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep2SustainabilityReportHelp") ||
                "Pubblica bilanci di sostenibilità?"}
            </div>
          </label>
        </div>

        <div className="col-12">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="secondary_offices"
              checked={secondary_offices.present}
              onChange={(e) => setSecondaryOffices((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="secondary_offices">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep2SecondaryOfficesLabel") || "Sedi secondarie"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep2SecondaryOfficesHelp") ||
                  "Ci sono sedi secondarie?"}
              </div>
            </label>
          </div>
          {secondary_offices.present && (
            <div className="ml-4 mt-1">
              <label className="block text-sm mb-1">
                {localeText("businessDiagnosisStep2SecondaryOfficesWhere") || "Se Sì indicare dove"}
              </label>
              <InputText
                value={secondary_offices.locations}
                onChange={(e) => setSecondaryOffices((p) => ({ ...p, locations: e.target.value }))}
                className="w-full border-round-md"
              />
            </div>
          )}
        </div>
        <div className="col-12">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="industry_association"
              checked={industry_association_memberships.present}
              onChange={(e) => setIndustryAssociation((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="industry_association">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep2IndustryAssociationLabel") ||
                  "Iscrizioni ad associazioni di categoria"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep2IndustryAssociationHelp") ||
                  "Adesione ad associazioni di categoria."}
              </div>
            </label>
          </div>
          {industry_association_memberships.present && (
            <div className="ml-4 mt-1">
              <label className="block text-sm mb-1">
                {localeText("businessDiagnosisStep2IndustryAssociationWhich") ||
                  "Se Sì indicare quali"}
              </label>
              <InputText
                value={industry_association_memberships.which}
                onChange={(e) => setIndustryAssociation((p) => ({ ...p, which: e.target.value }))}
                className="w-full border-round-md"
              />
            </div>
          )}
        </div>
        <div className="col-12">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="interprofessional_funds"
              checked={interprofessional_funds.present}
              onChange={(e) => setInterprofessionalFunds((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="interprofessional_funds">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep2InterprofessionalFundsLabel") ||
                  "Fondi Interprofessionali"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep2InterprofessionalFundsHelp") ||
                  "Partecipazione a fondi interprofessionali."}
              </div>
            </label>
          </div>
          {interprofessional_funds.present && (
            <div className="ml-4 mt-1">
              <label className="block text-sm mb-1">
                {localeText("businessDiagnosisStep2InterprofessionalFundsWhich") ||
                  "Se SI indicare quale/i"}
              </label>
              <InputText
                value={interprofessional_funds.which}
                onChange={(e) =>
                  setInterprofessionalFunds((p) => ({ ...p, which: e.target.value }))
                }
                className="w-full border-round-md"
              />
            </div>
          )}
        </div>
        <div className="col-12">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="bilateral_entity"
              checked={bilateral_entity.present}
              onChange={(e) => setBilateralEntity((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="bilateral_entity">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep2BilateralEntityLabel") || "Ente Bilaterale"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep2BilateralEntityHelp") ||
                  "È iscritta a un ente bilaterale?"}
              </div>
            </label>
          </div>
          {bilateral_entity.present && (
            <div className="ml-4 mt-1">
              <label className="block text-sm mb-1">
                {localeText("businessDiagnosisStep2BilateralEntityWhich") || "Se SI indicare quale"}
              </label>
              <InputText
                value={bilateral_entity.which}
                onChange={(e) => setBilateralEntity((p) => ({ ...p, which: e.target.value }))}
                className="w-full border-round-md"
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-content-end gap-2 flex-wrap mt-2">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            style={{ color: "var(--theme-primary)" }}
            onClick={onBack}
            disabled={saving}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepCompanyStructure;
